import { supabase } from "@/lib/supabase";

export interface AuditLogEntry {
  actionType: string;
  entityType: string;
  entityId?: string;
  userId?: string;
  role?: string;
  reason?: string;
  previousValue?: Record<string, unknown>;
  newValue?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
  relatedRuleCode?: string;
  outcome: "success" | "failed" | "overridden" | "blocked";
}

export const AuditLogService = {
  async create(entry: AuditLogEntry): Promise<void> {
    const { data: { user } } = await supabase.auth.getUser();
    const userId = entry.userId || user?.id || "system";

    await supabase
      .from("audit_log")
      .insert({
        action_type: entry.actionType,
        entity_type: entry.entityType,
        entity_id: entry.entityId,
        user_id: userId,
        role: entry.role,
        reason: entry.reason,
        previous_value: entry.previousValue || {},
        new_value: entry.newValue || {},
        metadata: entry.metadata || {},
        related_rule_code: entry.relatedRuleCode,
        outcome: entry.outcome,
        timestamp: new Date().toISOString(),
      })
      .catch(() => {});
  },

  async getByEntity(entityType: string, entityId: string, limit = 50) {
    const { data, error } = await supabase
      .from("audit_log")
      .select("*")
      .eq("entity_type", entityType)
      .eq("entity_id", entityId)
      .order("timestamp", { ascending: false })
      .limit(limit);
    return { data, error };
  },
};